import {FormioBase} from "./formiobase";

export class TextField extends FormioBase {
  public inputType = "text";
  public title = "Text Field";
  public icon = "fa fa-terminal";
  public schema: any = {
    title: "textfield",
    components: [{
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "TextField",
      key: undefined,
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      notvisible: false,
      allowCalculateOverride: true,
      validate: {
        required: false,
        minLength: 0,
        maxLength: 255,
        pattern: "",
        custom: "",
        customPrivate: false,
        validationLink: null,
      },
      type: "textfield",
      disabled: false,
      tags: [],
      description: "",
      tooltip: "",
      customClass: "ds-textfield",
    }],
  };
}
